import { getEntityId } from '@/utils';
import { TUploadConditionReportFields, UploadConditionReportFields } from '../helpers';
import { IUpdateAppraisalOrderDTO } from '@/models/order.model';

class UpdateAppraiserStepDTO implements Partial<IUpdateAppraisalOrderDTO> {
  condition_report_created_at: string;
  price: number;
  rate_report_created_at: string;
  id: string;

  constructor(
    values: TUploadConditionReportFields & {
      id: string;
    },
  ) {
    this.id = getEntityId(values.id);
    this.condition_report_created_at = values[UploadConditionReportFields.CONDITION_REPORT_CREATED_AT];
    this.price = values[UploadConditionReportFields.PRICE];
    this.rate_report_created_at = values[UploadConditionReportFields.RATE_REPORT_CREATED_AT];
  }
}

export default UpdateAppraiserStepDTO;
